import { createContext } from "react";
import { BankingSDKConnectorsRecipientsPivot } from "ui/forms/OpenBanking";

type Context = BankingSDKConnectorsRecipientsPivot.BankingSDKConnectorsRecipientsPivotProps;

export const BankingSDKConnectorsRecipientsPivotFormContext = createContext<Context>({} as Context);
